// extracted by mini-css-extract-plugin
export default {"popoverContent":"policies_breakdown_popoverContent__q1yS1","popover":"policies_breakdown_popover__wZqol"};